module.exports = __webpack_public_path__ + "img/2.850e916d.png";